import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__